var exports = {
  "container": "x43cbe9c2--ef4b31--container",
  "wrapper": "x43cbe9c2--ef4b31--wrapper",
  "first-blue": "x43cbe9c2--ef4b31--first-blue",
  "first-white": "x43cbe9c2--ef4b31--first-white",
  "content": "x43cbe9c2--ef4b31--content",
  "main-title": "x43cbe9c2--ef4b31--main-title",
  "main-title-outside": "x43cbe9c2--ef4b31--main-title-outside",
  "nav-container": "x43cbe9c2--ef4b31--nav-container",
  "step": "x43cbe9c2--ef4b31--step",
  "sale": "x43cbe9c2--ef4b31--sale",
  "rent": "x43cbe9c2--ef4b31--rent",
  "host": "x43cbe9c2--ef4b31--host",
  "step-text": "x43cbe9c2--ef4b31--step-text",
  "title": "x43cbe9c2--ef4b31--title",
  "arrows": "x43cbe9c2--ef4b31--arrows",
  "arrow": "x43cbe9c2--ef4b31--arrow",
  "arrow-next": "x43cbe9c2--ef4b31--arrow-next",
  "arrow-prev": "x43cbe9c2--ef4b31--arrow-prev",
  "banner": "x43cbe9c2--ef4b31--banner",
  "tablet": "x43cbe9c2--ef4b31--tablet",
  "phone": "x43cbe9c2--ef4b31--phone",
};

module.exports = exports;
